<template>
  <main class=" w-100">
    <div class="containerimg" style="height: 85vh;">
      <img loading="lazy" src="@/assets/images/mainlanding.jpeg" alt="Snow" style="width:100%;height: 100%;object-fit: cover;">
      <div class="bottom-left text-start p-5">
        <h2 class="text-white text-uppercase" >Your IT Partner</h2>
        <h2 class="text-white text-uppercase kebaikan">for Seamless Growth</h2>
      </div>
    </div>
  </main>
  <section id="about" class="bg-darkblue d-flex align-items-center justify-content-center ">

    <div class="container p-2">
      <p class="lead text-center f-md mt-2">
        {{ $t('Summary') }}
      </p>

    </div>
  </section>

  <section id="beneficial" class="bg-darkgrey p-5  d-flex align-items-center justify-content-center">

    <div class="container">
      <h6 class="mb-5 text-start text-uppercase"><i class="fas fa-circle me-2 text-lightblues"></i><b
          class="text-light">{{ $t('Tag_KeyValue') }}</b></h6>
      <div class="row">
        <div class="col-lg-4 text-center">
          <img loading="lazy" src="@/assets/images/inovation.png" class="bd-placeholder-img rounded-circle" alt="Snow"
            style="width:140px;height:140px">
          <h5 class="fw-normal mt-2 text-light"><b>{{ $t('Value_Title_1') }}</b></h5>
          <p class="text-lightblues">{{ $t('Value_P_1') }}</p>

        </div><!-- /.col-lg-4 -->
        <div class="col-lg-4 text-center">
          <img loading="lazy" src="@/assets/images/relability.png" class="bd-placeholder-img rounded-circle" alt="Snow"
            style="width:140px;height:140px">

          <h5 class="fw-normal mt-2 text-light"><b>{{ $t('Value_Title_2') }}</b></h5>
          <p class="text-lightblues">{{ $t('Value_P_2') }}</p>

        </div><!-- /.col-lg-4 -->
        <div class="col-lg-4 text-center">
          <img loading="lazy" src="@/assets/images/costumer.png" class="bd-placeholder-img rounded-circle" alt="Snow"
            style="width:140px;height:140px">
          <h5 class="fw-normal mt-2 text-light"><b>{{ $t('Value_Title_3') }}</b></h5>
          <p class="text-lightblues">{{ $t('Value_P_3') }}</p>
        </div>
      </div>
    </div>
  </section>

  <section class="   align-items-center justify-content-center product_service">
    <div class="container">
      <h6 class="text-start text-uppercase pt-5"><i class="fas fa-circle me-2 text-lightblues"></i><b class="text-white">{{
          $t('Tag_Product') }}</b></h6>
      <div class=" pb-5 ">
        <div class="container">
          <div class="row p-5 row-cols-1 row-cols-sm-2 row-cols-md-5 g-2">
            <div class="col">
              <div class="card rounded-none border-blue bg-darkblue">
                <div class="img-wrap">
                  <ul>
                    <li>
                      <img loading="lazy" class="w-100" src="@/assets/images/product-img_1.jpeg" />
                      <div class="img-description">
                        <router-link class="btn  btn-sm btn-outline-light me-2 text-uppercase " style="border-radius: 0 !important;"  to="/product">
                          {{ $t('Product_Btn') }}
                       </router-link>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-center">
                    <img loading="lazy" style="width:95%;" src="@/assets/images/logo-uiux.png" alt="">
                  </div>

                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-darkblue rounded-none border-blue">
                <div class="img-wrap">
                  <ul>
                    <li>
                      <img loading="lazy" class="w-100" src="@/assets/images/product-img_2.jpeg" />
                      <div class="img-description">
                        <router-link class="btn  btn-sm btn-outline-light me-2 text-uppercase " style="border-radius: 0 !important;"  to="/product">
                          {{ $t('Product_Btn') }}
                       </router-link>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-center">
                    <img loading="lazy" style="width:95%;" src="@/assets/images/logo-webdev.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-darkblue rounded-none border-blue">
                <div class="img-wrap">
                  <ul>
                    <li>
                      <img loading="lazy" class="w-100" src="@/assets/images/product-img_3.jpeg" />
                      <div class="img-description">
                        <router-link class="btn  btn-sm btn-outline-light me-2 text-uppercase " style="border-radius: 0 !important;"  to="/product">
                          {{ $t('Product_Btn') }}
                       </router-link>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-center">
                    <img loading="lazy" style="width:95%;" src="@/assets/images/logo-appdev.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-darkblue rounded-none border-blue">
                <div class="img-wrap">
                  <ul>
                    <li>
                      <img loading="lazy" class="w-100" src="@/assets/images/product-img_4.jpeg" />
                      <div class="img-description">
                        <router-link class="btn  btn-sm btn-outline-light me-2 text-uppercase " style="border-radius: 0 !important;"  to="/product">
                          {{ $t('Product_Btn') }}
                       </router-link>
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-center">
                    <img loading="lazy" style="width:95%;" src="@/assets/images/logo-svm.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-darkblue rounded-none border-blue">
                <div class="img-wrap">
                  <ul>
                    <li>
                      <img loading="lazy" class="w-100" src="@/assets/images/product-img_5.jpeg" />
                      <div class="img-description">
                        <router-link class="btn  btn-sm btn-outline-light me-2 text-uppercase " style="border-radius: 0 !important;"  to="/product">
                          {{ $t('Product_Btn') }}
                       </router-link>
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-center">
                    <img loading="lazy" style="width:95%;" src="@/assets/images/logo-netman.png" alt="">
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


    </div>


  </section>

</template>

<script src="@/assets/js/home.js"></script>
